import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mq = '@media print';
  return {
    stemWrapper: {
      flex: '20 20 auto',
      marginBottom: componentTheme.stemWrapperMarginBottom,
      marginLeft: componentTheme.stemWrapperMarginLeft,
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center'
    },
    stemItem: {
      alignItems: 'center',
      margin: componentTheme.stemItemMargin,
      fontSize: componentTheme.stemItemFontSize,
      display: 'flex'
    },
    selectPlaceholder: {
      color: componentTheme.selectPlaceholderColor
    },
    noPrintBlank: _defineProperty({
      display: 'inline-block'
    }, mq, {
      display: 'none'
    }),
    printBlank: _defineProperty({
      display: 'none'
    }, mq, {
      display: 'inline-block'
    })
  };
};
export default generateStyle;